import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { H5 } from '../../../AbstractElements';
import { CryptoAnnotationsTitle } from '../../../Constant';
import { optionsAnnotation } from '../../Common/Data/ApexChart';

const CryptoAnnotations = ({ title = CryptoAnnotationsTitle, chartData = optionsAnnotation }) => {
  return (
    <Col xl='12' lg='12' xs='12' className=''>
      <Card>
        <CardHeader>
          <H5>{title}</H5>
        </CardHeader>
        <CardBody>
          <div className='chart-container'>
            <Row>
              <Col xs='12'>
                <div id='crypto-annotation'>
                  <ReactApexChart type='line' height={400} series={chartData.series} options={chartData.options} />
                </div>
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CryptoAnnotations;
